import { useState, useEffect } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Button } from "react-bootstrap";
import AddUnitModal from "./AddUnitModal";

function VendorProfiles(props) {
  const [profiles, setProfiles] = useState("");
  const [isUnitOpen, setIsUnitOpen] = useState(false);
  const { vendorId } = props;
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getAllProfiles = async () => {
      try {
        const response = await axiosPrivate.get(`profiles/id=${vendorId}`, {
          signal: controller.signal,
        });
        isMounted && setProfiles(response.data);
      } catch (err) {
        console.error(err);
      }
    };
    getAllProfiles();

    // Cleanup function
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [vendorId]);

  const handleUnitAdded = () => {
    // Re-fetch profiles when a new unit is added
    const controller = new AbortController();
    const getAllProfiles = async () => {
      try {
        const response = await axiosPrivate.get(`profiles/id=${vendorId}`, {
          signal: controller.signal,
        });
        setProfiles(response.data);
      } catch (err) {
        console.error(err);
      }
    };
    getAllProfiles();
  };

  const displayProfiles = (profiles) => {
    if (profiles.length > 0) {
      return profiles.map((profile, index) => {
        return (
          <div key={profile.id} className="row">
            <div className="col-md-8">
              <span className="hideDesktop">ENOTA: </span>
              {profile.name}
            </div>
            <div className="col-md-4">
              <span className="hideDesktop">STATUS: </span>
              {profile.status}
            </div>
          </div>
        );
      });
    } else {
      return (
        <div className="row">
          <div className="col-md-12 ">Podjetje nima še nobene enote</div>
        </div>
      );
    }
  };

  return (
    <div>
      <div className="prcVendorDetailsProfiles">
        <div className="row prcVendorDetailsTitleRow">
          <div className="col-sm-6">
            <strong>ENOTE</strong>
          </div>
          <div className="col-sm-6 text-sm-right">
            <Button variant="secondary" onClick={() => setIsUnitOpen(true)}>
              Dodaj enoto
            </Button>
          </div>
        </div>
        <div className="row prcVendorProfilesHeader hideMobile">
          <div className="col-md-8">
            <p>ENOTE</p>
          </div>
          <div className="col-md-4">
            <p>STATUS</p>
          </div>
        </div>
        {displayProfiles(profiles)}
        <AddUnitModal
          open={isUnitOpen}
          onClose={() => setIsUnitOpen(false)}
          vendorId={vendorId}
          onUnitAdded={handleUnitAdded}
        />
      </div>
    </div>
  );
}

export default VendorProfiles;
